<div id="myModal" class="modal fade" role="dialog" aria-modal="true" aria-labelledby="modalTitle">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content modal-shell">
            <div class="modal-body text-center modal-body-shell">
                <button type="button" class="close modal-close" (click)="closeModal()" aria-label="Close modal">
                    ×
                </button>
                <ng-container *ngIf="modal != null">
                    <ng-container *ngIf="modal.DetailsEn != null && modal.ShowAttachments == null">
                        <div class="modal-copy" id="modalTitle" [innerHTML]="modal.DetailsEn"></div>
                    </ng-container>
                    <ng-container *ngIf="modal.DetailsEn != null && modal.ShowAttachments != null">
                        <img class="modal-image" [src]="modal.ShowAttachments[0].FilePath" alt="image" />
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</div>